export default "__VITE_ASSET__z6bs5n9R__";